// activityCommEnums.js - Constants and Helper Functions for Activity & Communication Module

// ==================== TASK PRIORITY ====================
export const TaskPriority = {
  LOW: 'LOW',
  MEDIUM: 'MEDIUM',
  HIGH: 'HIGH',
  CRITICAL: 'CRITICAL'
};

export const TaskPriorityLabels = {
  LOW: 'Low',
  MEDIUM: 'Medium',
  HIGH: 'High',
  CRITICAL: 'Critical'
};

export const TaskPriorityColors = {
  LOW: 'success',
  MEDIUM: 'info',
  HIGH: 'warning',
  CRITICAL: 'error'
};

export const TaskPriorityOptions = [
  { value: 'LOW', label: 'Low', color: 'success' },
  { value: 'MEDIUM', label: 'Medium', color: 'info' },
  { value: 'HIGH', label: 'High', color: 'warning' },
  { value: 'CRITICAL', label: 'Critical', color: 'error' }
];

// ==================== TASK STATUS ====================
export const TaskStatus = {
  PENDING: 'PENDING',
  IN_PROGRESS: 'IN_PROGRESS',
  COMPLETED: 'COMPLETED',
  CANCELLED: 'CANCELLED',
  DEFERRED: 'DEFERRED'
};

export const TaskStatusLabels = {
  PENDING: 'Pending',
  IN_PROGRESS: 'In Progress',
  COMPLETED: 'Completed',
  CANCELLED: 'Cancelled',
  DEFERRED: 'Deferred'
};

export const TaskStatusColors = {
  PENDING: 'default',
  IN_PROGRESS: 'primary',
  COMPLETED: 'success',
  CANCELLED: 'error',
  DEFERRED: 'warning'
};

export const TaskStatusOptions = [
  { value: 'PENDING', label: 'Pending', color: 'default' },
  { value: 'IN_PROGRESS', label: 'In Progress', color: 'primary' },
  { value: 'COMPLETED', label: 'Completed', color: 'success' },
  { value: 'CANCELLED', label: 'Cancelled', color: 'error' },
  { value: 'DEFERRED', label: 'Deferred', color: 'warning' }
];

// ==================== RECURRENCE FREQUENCY ====================
export const RecurrenceFrequency = {
  DAILY: 'DAILY',
  WEEKLY: 'WEEKLY',
  MONTHLY: 'MONTHLY',
  YEARLY: 'YEARLY',
  CUSTOM: 'CUSTOM'
};

export const RecurrenceFrequencyLabels = {
  DAILY: 'Daily',
  WEEKLY: 'Weekly',
  MONTHLY: 'Monthly',
  YEARLY: 'Yearly',
  CUSTOM: 'Custom'
};

export const RecurrenceFrequencyOptions = [
  { value: 'DAILY', label: 'Daily' },
  { value: 'WEEKLY', label: 'Weekly' },
  { value: 'MONTHLY', label: 'Monthly' },
  { value: 'YEARLY', label: 'Yearly' },
  { value: 'CUSTOM', label: 'Custom' }
];

// ==================== REMINDER TYPE ====================
export const ReminderType = {
  EMAIL: 'EMAIL',
  SMS: 'SMS',
  IN_APP: 'IN_APP'
};

export const ReminderTypeLabels = {
  EMAIL: 'Email',
  SMS: 'SMS',
  IN_APP: 'In-App Notification'
};

export const ReminderTypeOptions = [
  { value: 'EMAIL', label: 'Email' },
  { value: 'SMS', label: 'SMS' },
  { value: 'IN_APP', label: 'In-App Notification' }
];

// ==================== REMINDER STATUS ====================
export const ReminderStatus = {
  PENDING: 'PENDING',
  SENT: 'SENT',
  FAILED: 'FAILED',
  CANCELLED: 'CANCELLED'
};

export const ReminderStatusLabels = {
  PENDING: 'Pending',
  SENT: 'Sent',
  FAILED: 'Failed',
  CANCELLED: 'Cancelled'
};

export const ReminderStatusColors = {
  PENDING: 'default',
  SENT: 'success',
  FAILED: 'error',
  CANCELLED: 'warning'
};

// ==================== CALENDAR PROVIDER ====================
export const CalendarProvider = {
  GOOGLE: 'GOOGLE',
  OUTLOOK: 'OUTLOOK'
};

export const CalendarProviderLabels = {
  GOOGLE: 'Google Calendar',
  OUTLOOK: 'Microsoft Outlook'
};

export const CalendarProviderOptions = [
  { value: 'GOOGLE', label: 'Google Calendar' },
  { value: 'OUTLOOK', label: 'Microsoft Outlook' }
];

// ==================== CALENDAR SYNC STATUS ====================
export const CalendarSyncStatus = {
  ACTIVE: 'ACTIVE',
  PAUSED: 'PAUSED',
  ERROR: 'ERROR',
  DISCONNECTED: 'DISCONNECTED'
};

export const CalendarSyncStatusLabels = {
  ACTIVE: 'Connected',
  PAUSED: 'Paused',
  ERROR: 'Error',
  DISCONNECTED: 'Disconnected'
};

export const CalendarSyncStatusColors = {
  ACTIVE: 'success',
  PAUSED: 'warning',
  ERROR: 'error',
  DISCONNECTED: 'default'
};

// ==================== BOOKING PAGE STATUS ====================
export const BookingPageStatus = {
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE'
};

export const BookingPageStatusLabels = {
  ACTIVE: 'Active',
  INACTIVE: 'Inactive'
};

export const BookingPageStatusColors = {
  ACTIVE: 'success',
  INACTIVE: 'default'
};

// ==================== BOOKING SLOT STATUS ====================
export const BookingSlotStatus = {
  CONFIRMED: 'CONFIRMED',
  CANCELLED: 'CANCELLED',
  COMPLETED: 'COMPLETED',
  NO_SHOW: 'NO_SHOW'
};

export const BookingSlotStatusLabels = {
  CONFIRMED: 'Confirmed',
  CANCELLED: 'Cancelled',
  COMPLETED: 'Completed',
  NO_SHOW: 'No Show'
};

export const BookingSlotStatusColors = {
  CONFIRMED: 'primary',
  CANCELLED: 'error',
  COMPLETED: 'success',
  NO_SHOW: 'warning'
};

// ==================== EMAIL SYNC PROVIDER ====================
export const EmailSyncProvider = {
  GMAIL: 'GMAIL',
  OUTLOOK: 'OUTLOOK',
  BCC_DROPBOX: 'BCC_DROPBOX'
};

export const EmailSyncProviderLabels = {
  GMAIL: 'Gmail',
  OUTLOOK: 'Outlook',
  BCC_DROPBOX: 'BCC Dropbox'
};

export const EmailSyncProviderOptions = [
  { value: 'GMAIL', label: 'Gmail' },
  { value: 'OUTLOOK', label: 'Outlook' },
  { value: 'BCC_DROPBOX', label: 'BCC Dropbox' }
];

// ==================== COMMUNICATION DIRECTION ====================
export const CommunicationDirection = {
  INBOUND: 'INBOUND',
  OUTBOUND: 'OUTBOUND'
};

export const CommunicationDirectionLabels = {
  INBOUND: 'Inbound',
  OUTBOUND: 'Outbound'
};

// ==================== DAYS OF WEEK ====================
export const DaysOfWeek = [
  { value: 0, label: 'Sunday', short: 'Sun' },
  { value: 1, label: 'Monday', short: 'Mon' },
  { value: 2, label: 'Tuesday', short: 'Tue' },
  { value: 3, label: 'Wednesday', short: 'Wed' },
  { value: 4, label: 'Thursday', short: 'Thu' },
  { value: 5, label: 'Friday', short: 'Fri' },
  { value: 6, label: 'Saturday', short: 'Sat' }
];

// ==================== HELPER FUNCTIONS ====================

export const formatDate = (dateString) => {
  if (!dateString) return '-';
  return new Date(dateString).toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric'
  });
};

export const formatDateTime = (dateString) => {
  if (!dateString) return '-';
  return new Date(dateString).toLocaleString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  });
};

export const formatTimeAgo = (dateString) => {
  if (!dateString) return '-';

  const date = new Date(dateString);
  const now = new Date();
  const seconds = Math.floor((now - date) / 1000);

  if (seconds < 60) return 'Just now';
  if (seconds < 3600) return `${Math.floor(seconds / 60)} min ago`;
  if (seconds < 86400) return `${Math.floor(seconds / 3600)} hours ago`;
  if (seconds < 604800) return `${Math.floor(seconds / 86400)} days ago`;

  return formatDate(dateString);
};

export const formatDuration = (minutes) => {
  if (minutes === null || minutes === undefined) return '-';
  if (minutes < 60) return `${minutes} min`;
  if (minutes < 1440) return `${Math.round(minutes / 60)} hours`;
  return `${Math.round(minutes / 1440)} days`;
};

export const isOverdue = (dueDate, status) => {
  if (!dueDate || status === 'COMPLETED' || status === 'CANCELLED') return false;
  return new Date(dueDate) < new Date();
};

export const isDueToday = (dueDate) => {
  if (!dueDate) return false;
  const today = new Date();
  const due = new Date(dueDate);
  return due.toDateString() === today.toDateString();
};

export const isDueThisWeek = (dueDate) => {
  if (!dueDate) return false;
  const today = new Date();
  const due = new Date(dueDate);
  const weekEnd = new Date(today);
  weekEnd.setDate(weekEnd.getDate() + (7 - weekEnd.getDay()));
  return due >= today && due <= weekEnd;
};

export const getInitials = (name) => {
  if (!name) return '?';
  return name
    .split(' ')
    .map(part => part[0])
    .join('')
    .toUpperCase()
    .slice(0, 2);
};

export const truncateText = (text, maxLength = 100) => {
  if (!text) return '';
  if (text.length <= maxLength) return text;
  return text.slice(0, maxLength) + '...';
};


// ==================== WORKFLOW TYPE ====================
export const WorkflowType = {
  SERVICE_REMINDER: 'SERVICE_REMINDER',
  GENERAL_COMMUNICATION: 'GENERAL_COMMUNICATION',
  PAYMENT_FOLLOWUP: 'PAYMENT_FOLLOWUP',
  CUSTOM: 'CUSTOM'
};

export const WorkflowTypeLabels = {
  SERVICE_REMINDER: 'Service Reminder',
  GENERAL_COMMUNICATION: 'General Communication',
  PAYMENT_FOLLOWUP: 'Payment Follow-up',
  CUSTOM: 'Custom'
};

export const WorkflowTypeColors = {
  SERVICE_REMINDER: 'primary',
  GENERAL_COMMUNICATION: 'info',
  PAYMENT_FOLLOWUP: 'error',
  CUSTOM: 'default'
};

export const WorkflowTypeOptions = [
  { value: 'SERVICE_REMINDER', label: 'Service Reminder' },
  { value: 'GENERAL_COMMUNICATION', label: 'General Communication' },
  { value: 'PAYMENT_FOLLOWUP', label: 'Payment Follow-up' },
  { value: 'CUSTOM', label: 'Custom' }
];

// ==================== WORKFLOW TRIGGER TYPE ====================
export const WorkflowTriggerType = {
  MANUAL: 'MANUAL',
  AUTO_AFTER_SERVICE: 'AUTO_AFTER_SERVICE',
  AUTO_AFTER_PURCHASE: 'AUTO_AFTER_PURCHASE',
  AUTO_OVERDUE_PAYMENT: 'AUTO_OVERDUE_PAYMENT',
  SCHEDULED: 'SCHEDULED'
};

export const WorkflowTriggerTypeLabels = {
  MANUAL: 'Manual',
  AUTO_AFTER_SERVICE: 'After Service Completed',
  AUTO_AFTER_PURCHASE: 'After Purchase',
  AUTO_OVERDUE_PAYMENT: 'Overdue Payment',
  SCHEDULED: 'Scheduled'
};

export const WorkflowTriggerTypeOptions = [
  { value: 'MANUAL', label: 'Manual Trigger' },
  { value: 'AUTO_AFTER_SERVICE', label: 'Auto: After Service Completed' },
  { value: 'AUTO_AFTER_PURCHASE', label: 'Auto: After Purchase' },
  { value: 'AUTO_OVERDUE_PAYMENT', label: 'Auto: Overdue Payment' },
  { value: 'SCHEDULED', label: 'Scheduled' }
];

// ==================== WORKFLOW STEP TYPE ====================
export const WorkflowStepType = {
  SEND_EMAIL: 'SEND_EMAIL',
  SEND_SMS: 'SEND_SMS',
  CREATE_TASK: 'CREATE_TASK',
  SCHEDULE_APPOINTMENT: 'SCHEDULE_APPOINTMENT',
  SEND_NOTIFICATION: 'SEND_NOTIFICATION',
  WAIT_DELAY: 'WAIT_DELAY',
  CHECK_CONDITION: 'CHECK_CONDITION',
  REQUIRE_APPROVAL: 'REQUIRE_APPROVAL'
};

export const WorkflowStepTypeLabels = {
  SEND_EMAIL: 'Send Email',
  SEND_SMS: 'Send SMS',
  CREATE_TASK: 'Create Task',
  SCHEDULE_APPOINTMENT: 'Schedule Appointment',
  SEND_NOTIFICATION: 'Send Notification',
  WAIT_DELAY: 'Wait / Delay',
  CHECK_CONDITION: 'Check Condition',
  REQUIRE_APPROVAL: 'Require Approval'
};

export const WorkflowStepTypeOptions = [
  { value: 'SEND_EMAIL', label: 'Send Email' },
  { value: 'SEND_SMS', label: 'Send SMS' },
  { value: 'CREATE_TASK', label: 'Create Task' },
  { value: 'SCHEDULE_APPOINTMENT', label: 'Schedule Appointment' },
  { value: 'SEND_NOTIFICATION', label: 'Send Notification' },
  { value: 'WAIT_DELAY', label: 'Wait / Delay' },
  { value: 'CHECK_CONDITION', label: 'Check Condition' },
  { value: 'REQUIRE_APPROVAL', label: 'Require Approval' }
];

// ==================== WORKFLOW EXECUTION STATUS ====================
export const WorkflowExecutionStatus = {
  PENDING: 'PENDING',
  RUNNING: 'RUNNING',
  PAUSED: 'PAUSED',
  WAITING_DELAY: 'WAITING_DELAY',
  WAITING_APPROVAL: 'WAITING_APPROVAL',
  COMPLETED: 'COMPLETED',
  FAILED: 'FAILED',
  CANCELLED: 'CANCELLED'
};

export const WorkflowExecutionStatusLabels = {
  PENDING: 'Pending',
  RUNNING: 'Running',
  PAUSED: 'Paused',
  WAITING_DELAY: 'Waiting (Delay)',
  WAITING_APPROVAL: 'Waiting (Approval)',
  COMPLETED: 'Completed',
  FAILED: 'Failed',
  CANCELLED: 'Cancelled'
};

export const WorkflowExecutionStatusColors = {
  PENDING: 'default',
  RUNNING: 'primary',
  PAUSED: 'warning',
  WAITING_DELAY: 'info',
  WAITING_APPROVAL: 'warning',
  COMPLETED: 'success',
  FAILED: 'error',
  CANCELLED: 'default'
};

// ==================== STEP EXECUTION STATUS ====================
export const StepExecutionStatus = {
  PENDING: 'PENDING',
  RUNNING: 'RUNNING',
  COMPLETED: 'COMPLETED',
  FAILED: 'FAILED',
  SKIPPED: 'SKIPPED'
};

export const StepExecutionStatusLabels = {
  PENDING: 'Pending',
  RUNNING: 'Running',
  COMPLETED: 'Completed',
  FAILED: 'Failed',
  SKIPPED: 'Skipped'
};

export const StepExecutionStatusColors = {
  PENDING: 'default',
  RUNNING: 'primary',
  COMPLETED: 'success',
  FAILED: 'error',
  SKIPPED: 'warning'
};
